// extracted by css-extract-rspack-plugin
export default {"cls1":"CoauthorConfirmations-cls1_9gR","cls2":"CoauthorConfirmations-cls2_OUc CoauthorConfirmations-cls1_9gR"};